module.exports = __webpack_public_path__ + "media/images/svgs/icon-dash-d2183a80c9d0f93cdbef12845a84ae01.svg";